import {RfpItem, RfpOffer} from '@customer/types/rfp/RfpItem';
import Formatters from '@globals/Formatters';
import serverFetch from '@globals/ServerFetch';

export interface RfpListFilter {
	Label: string;
	Name: string;
	Type: string;
	Items?: any[];
	Value: any;
	Icon?: string;
	IsExpanded: boolean;
	IsTagFilter?: boolean;
}
export default class RfpsList {
	TotalResults = -1;

	Page = -1;

	Filters:RfpListFilter[] = [];

	FiltersCount = 0;

	CurrentFilter = {};

	Type = '';

	Loaded = false;

	LoadingMore = false;

	Rfps = [] as RfpItem[];

	AdditionalRfps = [] as RfpItem[];

	AdditionalRfpsSectionLabel = '';

	AdditionalRfpsSectionTooltip = '';

	NearbyRfps = [] as RfpItem[];

	Format = new Formatters();

	SearchModified = false;

	OnlineStatusList = {};

	IsLoading = false;

	AdditionalSections = {};

	ExpiredItemsCount = 0;

	SearchTimeout?:number;

	SearchLoader = false;

	ArchivedRfpsCount = 0;

	ShowBestRfps = false;

	DefaultSort = '';

	additionalBoxes = [] as RfpListAdditionalBoxItem[];

	publicRfpListUrl = '';

	expandLimitBanner = undefined as {
		categoryName: string, // "Układanie kostki brukowej"
		idFilter: number, // 2137
		limitIncreasedBy: string, // "zwiększony o 20%"
		clientsPerWeek: string, // "8-12 klientów na tydzień"
		cost: string, // "do 10 pkt tygodniowo"
		bannerHead: string, // "Możesz dotrzeć do...",
		bannerBody: string, // "Tylko w zeszłym miesiącu..."
	} | undefined;

	constructor(t) {
		this.Type = t;
	}

	PrepareFilters(filters = {}, availableFilters) { // eslint-disable-line no-unused-vars
		let result = [];

		const category = {
			Name: 'idCategories',
			Label: 'Kategoria',
			Type: 'multi',
			Items: [],
			Value: [],
		};

		const sort = {
			Name: 'sort',
			Label: 'Sortuj',
			Type: 'select',
			Items: [{
				Value: 'SORT_DATE',
				Label: 'Od najnowszych',
			},
			{
				Value: 'SORT_DISTANCE',
				Label: 'Od najbliższych',
			}],
			Value: 'SORT_DATE',
			Default: 'SORT_DATE',
		};

		if (this.DefaultSort) {
			sort.Value = this.DefaultSort;
			sort.Default = this.DefaultSort;
		}

		const search = {
			Name: 'search',
			Label: this.Type !== 'Rfps' ? 'Szukaj po nazwie zlecenia' : 'Szukaj po nazwie kontaktu',
			Type: 'string',
			Value: '',
		};

		const distance = {
			Name: 'distance',
			Label: 'Lokalizacja',
			Type: 'select',
			Items: [] as { Value:number | string, Label: string }[],
			Value: '',
		};

		const rfpType = {
			Name: 'rfpType',
			Label: 'Typ podmiotu',
			Type: 'select',
			Items: [
				{ Value: '', Label: 'Wszyscy' },
				{ Value: 'individual', Label: 'Osoby prywatne' },
				{ Value: 'company', Label: 'Firmy' },
			],
			Value: '',
		};

		if (this.Type === 'Rfps') {
			const otherFilters = [{
				Name: 'withPhone',
				Label: 'Z numerem potwierdzonym SMS',
				Type: 'bool',
				Value: false,
			},
			{
				Name: 'withAttachments',
				Label: 'Z załącznikami',
				Type: 'bool',
				Value: false,
			},
			{
				Name: 'notSeen',
				Label: 'Nieprzeczytane',
				Type: 'bool',
				Value: false,
			},
			{
				Name: 'noOffers',
				Label: 'Bez ofert',
				Type: 'bool',
				Value: false,
			},
			{
				Name: 'onlyDiscounts',
				Label: 'Przecenione',
				Type: 'bool',
				Value: false,
			},
			{
				Name: 'onlyFavourites',
				Label: 'Obserwowane',
				Type: 'bool',
				Value: false,
			},
			];

			result = [category, distance, rfpType, ...otherFilters, sort, search]; // , startDate
		}

		if (this.Type !== 'Rfps') {
			const folder = {
				Name: 'folder',
				Type: 'select',
				Label: 'Pokaż',
				Items: [
					{
						Value: 'INCOMING',
						Label: 'Przychodzące',
						Icon: 'chat',
					},
					{
						Value: 'FAVOURITE',
						Label: 'Obserwowane',
						Icon: 'star-off',
					},
					{
						Value: 'WON',
						Label: 'Potwierdzone',
						Icon: 'handshake',
					},
					{
						Value: 'ARCHIVED',
						Label: 'Archiwum',
						Icon: 'archive-small',
					},
				],
				Value: 'INCOMING',
				Default: 'INCOMING',
			};

			const otherFilters = [
				{
					Name: 'onlyIm',
					Label: 'Polecanie',
					Type: 'bool',
					Value: false,
				},
				{
					Name: 'onlyNew',
					Label: 'Nowy kontakt',
					Type: 'bool',
					Value: false,
				},
				{
					Name: 'onlySent',
					Label: 'Wysłana wiadomość',
					Type: 'bool',
					Value: false,
				},
				{
					Name: 'onlyUnread',
					Label: 'Nieprzeczytana wiadomość',
					Type: 'bool',
					Value: false,
				},
			];

			result = [search, folder, category, ...otherFilters, sort];
			result.push(distance, rfpType);
		}

		return result;
	}

	SetFilterQuery(filterQuery: string) {
		const filters = this.Filters;
		if (filterQuery) {
			for (const q of filterQuery.split(',')) {
				const qq = q.split(':');
				const filter = filters.find((f) => f.Label.toLowerCase().replace(/ /g, '-') === qq[0]);
				let val;
				if (!filter) { continue; }
				switch (filter.Type) {
				case 'bool': filter.Value = true; break;
				case 'select':
					filter.Value = (Number(qq[1]) == qq[1]) ? Number(qq[1]) : qq[1]; // eslint-disable-line eqeqeq
					break;
				case 'multi':
					if (qq[1]) {
						qq[1].split(';').forEach((e) => {
							filter.Value.push(Number(e));
						});
					}
					break;
				default: break;
				}
			}
		}
	}

	UpdateCategoryFilters(availableFilters) {
		const categoryFilter = this.Filters.find((f) => f.Name === 'idCategories');
		if (!(categoryFilter && availableFilters && availableFilters.categories)) { return; }

		if (!availableFilters.categories.length) {
			availableFilters.categories = [
				{ id: '1', name: 'Wszystkie' },
			];
		}

		const originalCategoryFilterValue = categoryFilter.Value;
		categoryFilter.Items = [];
		categoryFilter.Value = [];
		for (const category of availableFilters.categories) {
			categoryFilter.Items.push({ Value: category.id, Label: category.name });
			if (originalCategoryFilterValue.indexOf(category.id) > -1) {
				categoryFilter.Value.push(category.id);
			}
		}
	}

	FiltersToQuery() {
		const result = [];
		for (const f of this.Filters) {
			if (f.Value === '' || (Array.isArray(f.Value) && !f.Value.length) || f.Value === false || f.IsTagFilter) { continue; }
			const name = f.Label.replace(/ /g, '-').toLowerCase();
			if (name === 'sortuj') { continue; }
			switch (f.Type) {
			case 'bool': result.push(name); break;
			case 'select': result.push(`${name}:${f.Value}`); break;
			case 'multi': result.push(`${name}:${f.Value.join(';')}`); break;
			default: break;
			}
		}
		return result.join(',');
	}

	PrepareFiltersUrl(filters) {
		let result = '';
		const dataObject = {} as any;
		const tags = [];
		filters = filters.filter((f) => {
			const v = f.Value;
			return (v === true || v.length || (typeof v === 'number' && String(v).length)) && v !== f.Default || f.Name === 'sort';
		});

		for (const f of filters) {
			if (f.IsTagFilter) {
				tags.push(f.Label);
				continue;
			}

			dataObject[`data.${f.Name}`] = f.Value;

			if (Array.isArray(f.Value)) {
				f.Value.forEach((v) => {
					result += `&data.${f.Name}=${v}`;
				});
			} else {
				result += `&data.${f.Name}=${f.Value}`;
			}

			if (f.Name === 'onlyFavourites') {
				dataObject['data.folder'] = 'FAVOURITE';
				result += '&data.folder=FAVOURITE';
			}
		}

		dataObject['data.tags'] = tags;

		// Nie liczymy sortowania jako filtr
		let count = filters.length;
		if (dataObject['data.sort']) {
			count -= 1;
		}

		return {
			Url: result,
			DataObject: dataObject,
			Count: count,
		};
	}

	GetListUrl(limit = 25) {
		return `/myoferteo/konto-json/${this.Type === 'Rfps' ? 'zapytania' : 'kontakty'}.ofer?data.limit=${limit}`;
	}

	GetContactPerson(cp, rfp) {
		cp = {
			ShortName: cp.shortName,
			FirstName: cp.firstName,
			LastName: cp.lastName,
			CompanyName: cp.companyName,
			Email: cp.email,
			Phone: cp.phone,
			Sex: cp.sex,
			OnlineStatus: cp.onlineStatus,
			Nip: cp.nip,
			OnlineStatusId: null,
			CustomerId: (rfp && rfp.idCustomer) ? rfp.idCustomer : 0,
			RfpId: rfp.id,
		};
		cp.OnlineStatusId = cp.RfpId;
		return cp;
	}

	ReplaceHTML(input: string): string {
		const tagsToRemove = new Set([
			'a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo',
			'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup',
			'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed',
			'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
			'head', 'header', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend',
			'li', 'link', 'main', 'map', 'mark', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol',
			'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rb', 'rp',
			'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'slot', 'small', 'source',
			'span', 'strong', 'style', 'sub', 'summary', 'sup', 'svg', 'table', 'tbody', 'td', 'template',
			'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video',
			'wbr',
		]);

		const pattern = new RegExp(`<\\/?(?:${Array.from(tagsToRemove).join('|')})[\\s\\S]*?>`, 'gi');
		const output = input.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
		const finalOutput = output.replace(pattern, '');

		return finalOutput;
	}

	GetRfpDescription(rfp) {
		const r = [];
		r.push({
			Label: 'Kategoria',
			Value: rfp.Category[1],
			HideInPublic: true,
		});

		const l = rfp.Location;
		let location = `${l.City[1]}, `;
		if (rfp.cityDistrict) {
			location += `dzielnica ${rfp.cityDistrict}, `;
		}
		location += (l.Country[0] === 'locationPl') ? `${l.District[1]}, ${l.Region[1]}` : l.Country[1];
		r.push({
			Label: 'Miejsce',
			Value: location,
		});

		if (rfp.IsUncovered && rfp.ContactPerson.Nip) {
			r.push({
				Label: 'NIP',
				Value: rfp.ContactPerson.Nip,
			});
		}

		if (rfp.IsUncovered && rfp.ContactPerson.CompanyName) {
			r.push({
				Label: 'Nazwa firmy',
				Value: rfp.ContactPerson.CompanyName,
			});
		}

		if (rfp.TransportInfo) {
			const transport = (label, v) => {
				if (!rfp.TransportInfo[v]) {
					return;
				}
				r.push({
					Label: label,
					Value: rfp.TransportInfo[v],
				});
			};
			transport('Załadunek', 'AddressFrom');
			transport('Rozładunek', 'AddressTo');
			transport('Termin załadunku od', 'FromDate');
			transport('Termin rozładunku do', 'ToDate');
			transport('Nadwozie', 'CargoBody');
			transport('Ciężar ładunku', 'CargoWeight');
			transport('Rodzaj ładunku', 'CargoType');
		}

		const description = this.ReplaceHTML(rfp.Description).split('\n');
		const d = [];
		for (let line of description) {
			try {
				line = line.trim();
				if (!line) {
					continue;
				}
				line = line.split(/(.+?:) (.+)/gm);
				if (line.length === 1) {
					line = line[0];
					if (line.endsWith(':')) {
						d.push({
							Label: line.replace(':', ''),
							Value: '',
						});
					} else {
						const val = line.startsWith('- ') ? `<div class="description-point">${line.replace('- ', '')}</div>` : `${line}<br>`;
						if (d.length >= 1) {
							d[d.length - 1].Value += val;
						}
					}
				} else {
					d.push({
						Label: line[1],
						Value: line[2],
					});
				}
			} catch (err) {
			}
		}

		const other = [{
			Label: 'Forma kontaktu',
			Value: rfp.ContactForms.join(', ').replace('Telefon, Telefon', 'Telefon'),
		},
		{
			Label: 'Identyfikator zapytania',
			Value: rfp.Id,
		},
		];

		if (rfp.DiscountReason) {
			other.push({ Label: 'Powód przeceny', Value: rfp.DiscountReason });
		}

		return [...r, ...d, ...other];
	}

	async SimulateFilterChange(filter) {
		const filtersCopy = JSON.parse(JSON.stringify(this.Filters));
		if (filter) {
			const replaceIdx = filtersCopy.findIndex((item) => item.Name === filter.Name);
			if (replaceIdx > -1) {
				filtersCopy[replaceIdx] = filter;
			}
		}
		const url = this.GetListUrl(1) + this.PrepareFiltersUrl(filtersCopy).Url;
		const replacedUrl = url.replace('zapytania.ofer?', 'rfps-counts.ofer?searchUncoverData=false&');
		// TODO: Liczba nie uzględnia filtrów tagów.
		return (await serverFetch(replacedUrl)).total;
	}

	getOffers(offers: any[]) {
		const result = [] as RfpOffer[];

		const mapOfferUncoverType = (type: string) => {
			if (type === 'uncCustSK') { return 'quick'; }
			if (type === 'uncBuyerAP') { return 'automatic'; }
			return '';
		};

		for (const offer of offers) {
			result.push({
				name: offer.name,
				date: this.Format.Date(offer.date),
				reviewsCount: offer.reviewsCount,
				ratingAverage: (offer.rating).toFixed(1),
				ratingStars: Number((offer.rating * 2)).toFixed(0),
				customerId: offer.idCustomer,
				uncoverType: mapOfferUncoverType(offer.idUncoverType),
				avatarIndex: offer.avatarIndex || 0,
				avatarColorIndex: offer.avatarColorIndex || 0,
			});
		}
		return result;
	}

	ProcessRfp(r) {
		if (!r) {
			r = {};
		}

		let uncoverType = 'NONE'; // MANUAL, QC, IM, REFUND
		if (r.uncoverType === 'uncCustManual') {
			uncoverType = 'MANUAL';
		}
		if (r.uncoverType === 'uncCustSK') {
			uncoverType = 'QC';
		}
		if (r.uncoverType === 'uncBuyerAP') {
			uncoverType = 'IM';
		}
		if (r.uncoverType === 'uncBuyerPF') {
			uncoverType = 'PF';
		}
		if (r.uncoverType === 'uncFreeBuyerChoice') {
			uncoverType = 'BC';
		}

		const originalCreationDate = r.startDate ? this.Format.Date(r.startDate) : this.Format.Date(r.creationDate);

		const rfp = {
			Id: r.id || 0,
			Title: r.title || ' ',
			Url: r.titleForUrl || '0',
			IsUnread: r.unread,
			IsExpired: r.expired || r.disableReason === 'INACTIVE_RFP', // bez sensu, to backend powinien.
			IsSeen: r.isSeen,
			IsFavourite: r.favourite,
			IsUncovered: r.uncovered && !r.refundReason, // Traktujemy zwroty jak nieodkryte.
			UncoverInProgress: false,
			PriceBelowMinimumVague: r.priceBelowMinimumVague,
			ConfirmedByBuyer: r.confirmedByBuyer,
			BuyerUndecidedNotChecked: r.buyerUndecidedNotChecked,
			BuyerUndecided: r.buyerUndecided,
			BuyerWithSmallBudget: r.buyerWithSmallBudget,
			BuyerWithSmallBudgetAfterCall: r.buyerWithSmallBudgetAfterCall,
			BuyerWithoutPhone: r.buyerWithoutPhone,
			UncoverType: uncoverType,
			DisableReason: r.disableReason === 'INACTIVE_RFP' ? '' : r.disableReason,
			RefundReason: r.refundReason,
			ContactPrice: r.contactPrice,
			OriginalContactPrice: r.originalContactPrice,
			IsDiscounted: r.isDiscounted,
			Tags: r.tags || [],
			AdditionalTags: r.additionalTags || [],
			RealizationDate: r.realizationDate,
			Description: r.description,
			CreationDate: originalCreationDate,
			CreationDateForList: r.tsRefreshedWithoutOffers ? this.Format.Date(r.tsRefreshedWithoutOffers) : originalCreationDate,
			StartDate: this.Format.Date(r.startDate),
			UncoverDate: this.Format.Date(r.tsUncovered),
			tsRefreshedWithoutOffers: r?.tsRefreshedWithoutOffers,
			Size: null,
			SizeLabel: r.sizeLabel || '',
			Category: r.category ? [r.category.id, r.category.name] : ['', ''],
			CategoryParent: r.categoryParent ? [r.categoryParent.id, r.categoryParent.name] : ['', ''],
			FirstUncoverFree: r.category ? r.category.tsFirstUncoverFree > 0 : false,
			HasChat: r.hasChat,
			ChatId: r.idChat,
			ChatUrl: r.chatUrl,
			ShowIdentityVerificationBox: r.showIdentityVerificationBox,
			LastMessage: r.lastMessage ? {
				Message: r.lastMessage.content ? r.lastMessage.content : '',
				IsMine: r.lastMessage.mine,
				IsRead: r.lastMessage.tsRead > 0,
				UnreadMessagesCount: r.unreadMessagesCount || -1,
				LastChatAction: r.tsLastChatAction || 0,
			} : {},
			ContactPerson: null,
			Location: null,
			ContactForms: ['Email', 'Czat'],
			Folder: r.idFolder,
			OffersCount: r.offersCount,
			Offers: [] as RfpOffer[],
			HasPhone: r.contactPerson ? (r.contactPerson.phone || '').length > 0 : false,
			PhoneConfirmed: r.tsPhoneConfirmed > 0,
			EmailConfirmed: r.tsEmailConfirmed > 0 && !r.emailFaulty,
			TransportInfo: null,
			Notes: [],
			Autorefund: false,
			AutorefundRfps: [],
			RefundDate: new Date(r.tsRefund) || null,
			PhoneConfirmationStatus: '',
			ClientRequestData: r.clientRequestData,
			UncoverLimit: r.uncoversLimit,
			IsSold: (typeof r.isSold !== 'undefined') ? r.isSold : (r.offersCount >= r.uncoversLimit),
			UncoverInactiveReason: r.uncoverInactiveReason || '',
			RegisterUrl: '/rejestracja/wybierz-klientow/',
			LoadFromData: {
				startDateFrom: r.startDate,
				expiredFrom: r.expired,
				chatDateFrom: (r.lastMessage || {}).tsCreated,
				creationDateCustomerRfpFrom: r.creationDateCustomerRfp,
				recommendedDateFrom: r.recommendedDate,
				distanceFrom: r.distanceFromCustomerHead,
			},
			NipVerificationStatus: '', // NeedsVerification, VerficationSent, VerificationInProgress,
			PdfUrl: r.pdfUrl,
			EditRfpLink: r.editRfpUrl,
			CooperationStatus: (r.cooperationConfirmationStatus || '').indexOf('confirmedBy') > -1 ? 'confirmed' : r.cooperationStatus || '', // '', 'Confirm'
			CooperationBadge: r.cooperationBadge || '', // '', 'Confirmed', 'BuyerConfirmed', 'ReviewRequest', 'Done', 'DEBUG', 'MarkRequest', 'MarkRequestSent'
			CooperationStartDate: new Date(r.cooperationConfirmationTsCreated),
			InvalidRedirect: r.invalidRedirect || '',
			DiscountReason: '',
			RedirectToList: false,
			HasAttachments: r.hasAttachments || false,
			Attachments: r.attachments || [],
			InactiveReason: '',
			BlockedUncoverLimit: r.blockedUncoverLimit || 0,
			rfpUncoverLimitLeft: r.rfpUncoverLimitLeft || 0,
			SimilarRfps: r.similarRfps?.slice(2).map((similarRfp) => this.ProcessRfp(similarRfp)) || [],
			isHideBuyerMail: r.hideBuyerMail,
			IsCustomerWaitingForOffers: r.isCustomerWaitingForOffers || false,
			creationDateLabel: r.creationDateLabel || '',
			distanceOverRange: r.distanceOverRange || '',
			canBeValuated: true,
			isValuated: r.valuated || false,
			canShowQuickContactBox: r.canShowQuickContactBox || false,
			canShowAutomaticRecommendationsBox: r.canShowAutomaticRecommendationsBox || false,
			isLastChance: r.isLastChance || false,
			operatorPhone: r.operatorPhone || '+48 664 210 066',
			onboardingFreeUncoversLeft: r.onboardingFreeUncoversLeft,
			cityDistrict: r.cityDistrict,
			refreshedWithoutOffers: r.refreshedWithoutOffers,
		};

		rfp.Attachments = rfp.Attachments.map((i) => ({ Name: i.fileName, Thumbnail: i.thumbnail, Path: i.path }));

		if (rfp.DisableReason === 'INACTIVE_POINTS') { rfp.UncoverInactiveReason = rfp.DisableReason; rfp.DisableReason = ''; }

		if (rfp.BlockedUncoverLimit) {
			rfp.UncoverInactiveReason = 'BLOCKED_POINTS';
		}

		if (r.negotiatedPriceVerificationStatus) {
			let nvs = '';
			if (r.negotiatedPriceVerificationStatus === 'notVerified') { nvs = 'NeedsVerification'; }
			if (r.negotiatedPriceVerificationStatus === 'underVerification') { nvs = 'VerificationInProgress'; }
			rfp.NipVerificationStatus = nvs;
		}

		if (r && r.category && r.location) {
			rfp.RegisterUrl += `?cats=${r.category.id}&loc=${r.location.city[1]}&rfpId=${r.id}`;
		}

		if (!r.notes) {
			r.notes = [];
		}
		for (const n of r.notes) {
			rfp.Notes.push({
				Id: n.id,
				Date: new Date(n.tsModified || n.tsCreated),
				Contents: n.note,
			});
		}

		if (!rfp.Id || !rfp.Title) {
			rfp.InvalidRedirect = '/zlecenia';
		}

		rfp.Location = r.location ? {
			Country: r.location.country,
			Region: r.location.region,
			District: r.location.district,
			City: r.location.city,
			Coords: r.location.coords,
		} : {
			Country: ['', ''],
			Region: ['', ''],
			District: ['', ''],
			City: ['', ''],
			Coords: ['', ''],
		};

		rfp.ContactPerson = r.contactPerson ? this.GetContactPerson(r.contactPerson, r) : {};

		if (!rfp.ContactPerson.Phone) {
			rfp.BuyerWithoutPhone = true;
			rfp.PhoneConfirmed = false;
		}
		if (!rfp.BuyerWithoutPhone) {
			rfp.ContactForms.unshift('Telefon');
		}

		if (r.fromAddress && r.toAddress) {
			const address = (v) => {
				const formatted = v.match(/(.+) (\d.+)/);
				return formatted ? `${formatted[2]}, ${formatted[1]}` : v;
			};
			rfp.TransportInfo = {
				AddressFrom: address(r.fromAddress),
				AddressTo: address(r.toAddress),
				FromDate: r.fromDate,
				ToDate: r.toDate,
				LocationFrom: r.fromLocation,
				LocationTo: r.toLocation,
				CargoBody: r.body,
				CargoWeight: r.weight,
				CargoType: r.cargoType,
			};
		}

		let discountReason = '';
		if (rfp.BuyerWithoutPhone && !rfp.PriceBelowMinimumVague) { discountReason = 'Zleceniodawca nie podał numeru telefonu'; }
		if (rfp.BuyerWithSmallBudgetAfterCall) { discountReason = 'Budżet niższy niż zwykle'; }
		if (rfp.BuyerWithSmallBudget || (!rfp.PriceBelowMinimumVague && (rfp.BuyerUndecided || rfp.BuyerUndecidedNotChecked))) { discountReason = 'Termin zlecenia jest odległy'; }
		if (rfp.IsDiscounted) { discountReason = 'Inny powód przeceny'; }
		rfp.DiscountReason = discountReason;

		rfp.Description = r.description ? this.GetRfpDescription(rfp) : [];

		rfp.Offers = this.getOffers(r.offers || []);
		rfp.OffersCount = rfp.Offers.length;

		if (rfp.OffersCount) {
			rfp.FirstUncoverFree = false;
		}

		if (rfp.OffersCount >= rfp.UncoverLimit) { rfp.IsSold = true; }

		// Automatyczny zwrot punktów.
		if (Array.isArray(r.uncoveredDuplicate) && r.uncoveredDuplicate.length) {
			rfp.Autorefund = true;
			for (const d of r.uncoveredDuplicate) {
				rfp.AutorefundRfps.push({
					id: d.id,
					title: d.title,
				});
			}
		}

		if (r.refundReason === 'Automatyczny zwrot punktów za ponowne odkrycie danych kontaktowych') {
			rfp.Autorefund = true;
		}

		if (rfp.IsUncovered) {
			// Odkryte zapytania nie powinny mieć informacji o tym, czy wygasło lub jest sprzedane.
			rfp.IsExpired = false;
			rfp.IsSold = false;
			rfp.InvalidRedirect = '';
		} else {
			// TODO: Wypisz tutaj wartość tekstową.
			rfp.InactiveReason = rfp.IsSold || rfp.IsExpired || rfp.InvalidRedirect || rfp.RefundReason || rfp.Autorefund || rfp.DisableReason;
		}

		return rfp;
	}

	RefreshCurrent() {
		this.Get({
			RefreshCurrent: true,
		});
	}

	async Get(options = {
		RefreshCurrent: false,
		LoadFrom: undefined,
		Filters: undefined,
		Query: undefined,
	}) {
		const result = {
			Rfps: [] as RfpItem[],
		};

		if (!options.LoadFrom) { this.ExpiredItemsCount = 0; }
		this.LoadingMore = true;

		let limit = 25;
		if (options.RefreshCurrent && this.Rfps.length) {
			limit = this.Rfps.length;
		}
		let url = this.GetListUrl(limit);

		if (options.LoadFrom) {
			url += `&data.idRfpFrom=${options.LoadFrom.Id}`;
			for (const param in options.LoadFrom.LoadFromData) {
				url += `&data.${param}=${options.LoadFrom.LoadFromData[param] || ''}`;
			}
		}

		let l;
		this.IsLoading = true;
		if (this.Filters.length) {
			const pfu = this.PrepareFiltersUrl(this.Filters);
			this.FiltersCount = pfu.Count;
			l = await serverFetch(url, pfu.DataObject, 'POST');
			this.DefaultSort = l.defaultSort;
		} else {
			l = await serverFetch(url);
			this.DefaultSort = l.defaultSort;
			this.Filters = this.PrepareFilters(options.Filters, l.filter);
			if (options.Query) {
				this.SetFilterQuery(options.Query);
				const get = await this.Get(options);
				return get;
			}
		}

		this.UpdateCategoryFilters(l.filter);
		this.SetFilterQuery(options.Query);

		this.IsLoading = false;
		this.LoadingMore = false;

		if (!l) {
			l = {
				rfps: [],
			};
		}
		this.TotalResults = l.total;
		this.newApCategories = l.newApCategories;
		this.newApCategoriesOB = l.newApCategoriesOB;
		this.ArchivedRfpsCount = l.archivedRfpsCount || 0;

		this.additionalBoxes = l.additionalBoxes || [];
		this.expandLimitBanner = l.expandLimitBanner;
		this.publicRfpListUrl = l.publicRfpListUrl;

		if (document.location.href.includes('localhost')) {
			this.expandLimitBanner = {
				categoryName: 'Układanie kostki brukowej', // "Układanie kostki brukowej"
				idFilter: 18117858,
				limitIncreasedBy: 'zwiększony o 20%', // "zwiększony o 20%"
				clientsPerWeek: '8-12 klientów na tydzień', // "8-12 klientów na tydzień"
				cost: 'do 10 pkt tygodniowo', // "do 10 pkt tygodniowo"
				bannerHead: 'Możesz dotrzeć do 15 dodatkowych klientów!', // "Możesz dotrzeć do...",
				bannerBody: 'Tylko w zeszłym miesiącu ominęło Cię 48 potencjalnych zleceń przez niski limit w usłudze Polecania. Zwiększ limit o ok. 20%, aby docierać do większej ilości klientów.', // "Tylko w zeszłym miesiącu..."
			};
		}

		const osl = {};
		if (!l.rfps) { l.rfps = []; }

		l.rfps.forEach((r) => {
			r = this.ProcessRfp(r);
			r.section = 'main';
			const cp = r.ContactPerson;
			osl[cp.OnlineStatusId] = cp.OnlineStatus;
			result.Rfps.push(r);
			if (r.IsExpired) { this.ExpiredItemsCount++; }
		});

		// jeżeli lista na starcie składa się z samych wygaśniętych, traktuj ją jako pustą.
		if (this.Type === 'Rfps' && this.ExpiredItemsCount === result.Rfps.length && !options.LoadFrom) {
			result.Rfps = [];
			this.TotalResults = 0;
			this.ExpiredItemsCount = 0;
		}

		this.AdditionalRfps = [];
		if (!l.additionalRfps) { l.additionalRfps = []; }

		l.additionalRfps.forEach((r) => {
			r = this.ProcessRfp(r);
			r.section = 'additional';
			if (r.IsExpired) { return; }
			const cp = r.ContactPerson;
			osl[cp.OnlineStatusId] = cp.OnlineStatus;
			this.AdditionalRfps.push(r);
		});

		this.AdditionalRfpsSectionLabel = l.additionalRfpsSectionLabel || '';
		this.AdditionalRfpsSectionTooltip = l.additionalRfpsSectionTooltip || '';

		if (l.nearbyRfps) {
			l.nearbyRfps.forEach((r) => {
				r = this.ProcessRfp(r);
				r.section = 'nearby';
				if (r.IsExpired) { return; }
				const cp = r.ContactPerson;
				osl[cp.OnlineStatusId] = cp.OnlineStatus;
				this.NearbyRfps.push(r);
			});
		}

		this.OnlineStatusList = osl;

		if (options.LoadFrom) {
			this.Rfps = [...this.Rfps, ...result.Rfps];
		} else {
			this.Rfps = result.Rfps;
		}
		this.Loaded = true;
		return this.Rfps;
	}

	async UpdateOnlineStatus() {
		const b = [];
		const c = [];
		Object.keys(this.OnlineStatusList).forEach((u) => {
			if (u.startsWith('B')) {
				b.push(u.substr(1));
			}
			if (u.startsWith('C')) {
				c.push(u.substr(1));
			}
		});

		const bl = this.GetOnlineStatusList('buyers', b);
		const cl = this.GetOnlineStatusList('custs', c);
		Promise.all([bl, cl]).then((r) => {
			this.OnlineStatusList = {
				...r[0],
				...r[1],
			};
		});
	}

	LoadMore() {
		const lastRfp = (this.Rfps.length) ? this.Rfps[this.Rfps.length - 1] : null;
		return this.Get({
			LoadFrom: lastRfp,
		});
	}

	ToggleFavourite(rfp:RfpItem) {
		rfp.IsFavourite = !rfp.IsFavourite;
		serverFetch('/myoferteo/konto-json/ulubione-zapytanie.ofer', {
			'data.idRfp': rfp.Id,
			'data.favourite': rfp.IsFavourite,
		}, 'POST');
	}

	RemoveRfpFromList(rfp:RfpItem, index?:number) {
		const id = rfp.Id;
		if (!index) {
			index = this.Rfps.findIndex((r) => Number(r.Id) === Number(id));
		}

		if (index >= 0) {
			this.TotalResults--;
			this.Rfps.splice(index, 1);
		}

		// Check on other lists...
		const indexNearby = this.NearbyRfps.findIndex((r: RfpItem) => Number(r.Id) === Number(id));
		if (indexNearby >= 0) { this.NearbyRfps.splice(indexNearby, 1); }
		const indexAdditional = this.AdditionalRfps.findIndex((r: RfpItem) => Number(r.Id) === Number(id));
		if (indexAdditional >= 0) { this.AdditionalRfps.splice(indexAdditional, 1); }
	}

	RemoveRfp(rfp:RfpItem, index:number) {
		this.RemoveRfpFromList(rfp, index);
		serverFetch('/myoferteo/konto-json/usun-zapytanie.ofer', {
			'data.idRfps': rfp.Id,
		}, 'POST');
	}

	RemoveRfpsById(rfps) {
		const fd = new FormData();

		for (const id of rfps) {
			const toRemove = this.Rfps.findIndex((r) => Number(r.Id) === Number(id));
			if (toRemove < 0) { continue; }
			fd.append('data.idRfps', id);
			this.TotalResults--;
			this.Rfps.splice(toRemove, 1);
		}

		fetch('/myoferteo/konto-json/usun-zapytanie.ofer', {
			method: 'POST', mode: 'no-cors', credentials: 'include', body: fd,
		});
	}

	async removeMultipleRfpsById(ids: number[]) {
			const fd = new FormData();
			ids.forEach((id) => fd.append('data.idRfps', String(id)));

			await fetch('/myoferteo/konto-json/usun-zapytanie.ofer', {
				method: 'POST', mode: 'no-cors', credentials: 'include', body: fd,
			});

			await this.Get({ RefreshCurrent: true });
	}

	async ChangeFilter(filter?, filters?) {
		if (!filters) {
			filters = this.Filters;
		}

		if (filter) {
			const filterToFound = filters.find((f) => f.Name === filter.Name);
			if (filterToFound) { filterToFound.Value = filter.Value; }
		}

		await this.Get();
	}

	OnSearchFilter() {
		return new Promise((resolve) => {
			this.SearchModified = true;
			window.clearTimeout(this.SearchTimeout);
			this.SearchLoader = true;
			this.SearchTimeout = window.setTimeout(async () => {
				await this.Get();
				this.SearchLoader = false;
				resolve(undefined);
			}, 150);
		});
	}

	async GetRfp(rfpId:number, isPublic = false) {
		const url = isPublic ? '/public/json/find-rfp-data.ofer?idRfp=' : '/myoferteo/konto-json/zapytanie.ofer?data.idRfp=';
		const rsvp = await serverFetch(url + rfpId);

		let toProcess = rsvp;
		if (isPublic) {
			toProcess = rsvp?.rfpPublicDTO?.rfpData || {};
		}

		const rfp = this.ProcessRfp(toProcess);
		if (rsvp.redirectToList) {
			rfp.RedirectToList = rsvp.redirectToList;
		}
		return rfp;
	}
}
